// ------------------------------------------ header
var class_array = [];

function toggle_class(selector, cls, container_cls){

    console.log(container_cls, class_array[class_array.length -1])

    if(class_array[class_array.length -1] == container_cls){
        $("."+selector).removeClass(cls);
        class_array = [];
    }
    else{
        $("."+selector).addClass(cls);
        class_array.push(container_cls);
    }

    $(".row-display").addClass("d-none");
    $("."+container_cls).removeClass("d-none");
}

function hamburger_menu(){
  $('.icon-hamburger').toggleClass('active'); 
  $('.mobile-nav-sidebar').toggleClass('active');
  $("body").toggleClass("overflow-hidden");
}

$(document).ready(function() {
  $("main[role='main']").click(function(){
      if($(".desktop-nav-sidebar").hasClass("active")){
          class_array = [];
          $(".desktop-nav-sidebar").removeClass("active");
      }
      else if($(".mobile-nav-sidebar").hasClass("active")){
          $(".mobile-nav-sidebar").removeClass("active");
          $("body").removeClass("overflow-hidden");
          $(".icon-hamburger").removeClass("active");
          $('.has-dropdown').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle(300);
          })
      }
  });
});
Shopify.money_format = "${{amount}}";

// 4/4/2022
$(document).on('click','button.search-icon', function(){
  $('.search-bar_container').toggleClass('open_search');
})
$(document).on('click','span.close_icon', function(){
  $('.search-bar_container').removeClass('open_search');
})

// ------------------------------------------ FAQ
 $(document).ready(function() {
    $('.questions').click(function() {
      var $faqData = $(this).find('.faq-data');
     

      var $faqPlus = $(this).find('.faq-plus');
      var $faqMinus = $(this).find('.faqminus');

      // Check if .faq-data has class 'hidden' to determine visibility
      var isDataHidden = $faqData.hasClass('hidden');
      console.log(isDataHidden)
       $faqData.slideToggle();
      if (!isDataHidden) {
        $faqPlus.removeClass('hidden');
        $faqMinus.addClass('hidden');
        $faqData.addClass('hidden');
      } else {
        $faqPlus.addClass('hidden');
        $faqMinus.removeClass('hidden');
        $faqData.removeClass('hidden');
      }
    });
  });
